import './event-listing-hero.html.twig';
import './event-listing-hero.scss';

function toggleDropDownDisplay(dropdown) {
  if (dropdown.classList.contains('event-listing-hero__filter-dropdown--hidden')) {
    dropdown.classList.remove('event-listing-hero__filter-dropdown--hidden');
    dropdown.parentElement.classList.add('event-listing-hero__filter-select--open');
    return;
  }

  dropdown.classList.add('event-listing-hero__filter-dropdown--hidden');
  dropdown.parentElement.classList.remove('event-listing-hero__filter-select--open');
}

function hideSelectedOption(options, selectedOption) {
  options.forEach(option => {
    const data = option.getAttribute('data-filter-option');
    if (data === selectedOption) {
      option.classList.add('event-listing-hero__filter-option--hidden');
      return;
    }
    option.classList.remove('event-listing-hero__filter-option--hidden');
  });
}

function setSelectedOption(selectedElement, options, selectedId) {
  options.forEach(option => {
    const optionId = option.getAttribute('data-filter-option');
    if (optionId === selectedId) {
      selectedElement.textContent = option.textContent;
    }
  });
}

function triggerClick(event) {
  if (event.keyCode == 13) {
    event.target.click();
  }
}

export default function () {
  const filters = {
    country: null,
    region: null,
  };

  let urlParams = new URLSearchParams(window.location.search);
  const el = document.querySelector('.event-listing-hero');
  const modal = document.querySelector('.event-listings-filter-modal');
  if (!el) {
    return;
  }
  const backgroundPicture = el.querySelector('.event-listing-hero__picture');
  const regionRow = el.querySelector('.event-listing-hero__region');
  const countrySelector = el.querySelector('.event-listing-hero__filter-select--country');
  const regionSelector = el.querySelector('.event-listing-hero__filter-select--region');
  const filterBtn = el.querySelector(".event-listing-hero__filter-btn");

  // Country Filters
  if (countrySelector) {
    const countryDropdown = countrySelector.querySelector('.event-listing-hero__filter-dropdown');
    const countrySelected = countrySelector.querySelector('.event-listing-hero__filter-selected');
    const countryOptions = countryDropdown.querySelectorAll('.event-listing-hero__filter-option');
    let selectedCountryId = '';


    if (urlParams.has('country')) {
      selectedCountryId = urlParams.get('country');
      if (selectedCountryId.length > 0) {
        setSelectedOption(countrySelected, countryOptions, selectedCountryId);
        hideSelectedOption(countryOptions, selectedCountryId);
        filters.country = selectedCountryId;
      }
    }

    countrySelector.addEventListener('click', () => {
      toggleDropDownDisplay(countryDropdown);
    });

    countrySelector.addEventListener('keypress', (e) => {
      triggerClick(e);
    });

    countryOptions.forEach(countryOption => {
      countryOption.addEventListener('click', () => {
        const countryID = countryOption.getAttribute('data-filter-option');
        filters.country = countryID;
        setSelectedOption(countrySelected, countryOptions, countryID);
        hideSelectedOption(countryOptions, countryID);

        // We've selected a country
        if (filters.country != null) {
          const filterParams = `?country=${filters.country}${filters.region != null ? `&region=${filters.region}` : ''}`;
          //Keep latitude and longitude params if set so we don't request them again if permission is granted
          const searchParams = new URLSearchParams(window.location.search);
          let latLonParams = "";
          if (searchParams.get('latitude') && searchParams.get('longitude')) {
            latLonParams =  "&latitude=" + searchParams.get('latitude') + "&longitude=" + searchParams.get('longitude');
          }
          window.location.href = window.location.origin + window.location.pathname + filterParams + latLonParams;
        };

      });

      countryOption.addEventListener('keypress', (e) => {
        triggerClick(e);
        toggleDropDownDisplay(countryDropdown);
      });
    });

  }

  // Region Filters
  if (regionSelector) {
    const regionDropdown = regionSelector.querySelector('.event-listing-hero__filter-dropdown');
    const regionSelected = regionSelector.querySelector('.event-listing-hero__filter-selected');
    const regionOptions = regionDropdown.querySelectorAll('.event-listing-hero__filter-option');
    let selectedRegionId = '';


    if (regionOptions.length > 0) {
      backgroundPicture.classList.add('event-listing-hero__picture--region-active');
      regionRow.classList.remove('event-listing-hero__region--hidden');
    }

    if (urlParams.has('region')) {
      selectedRegionId = urlParams.get('region');
      if (selectedRegionId.length > 0) {
        setSelectedOption(regionSelected, regionOptions, selectedRegionId);
        hideSelectedOption(regionOptions, selectedRegionId);
        filters.region = selectedRegionId;
      }
    }

    regionSelector.addEventListener('click', () => {
      toggleDropDownDisplay(regionDropdown);
    });

    regionSelector.addEventListener('keypress', (e) => {
      triggerClick(e);
    });

    regionOptions.forEach(regionOption => {
      regionOption.addEventListener('click', () => {
        const regionId = regionOption.getAttribute('data-filter-option');
        filters.region = regionId;
        setSelectedOption(regionSelected, regionOptions, regionId);
        hideSelectedOption(regionOptions, regionId);

        if (filters.country != null) {
          const filterParams = `?country=${filters.country}${filters.region != null ? `&region=${filters.region}` : ''}`
          //Keep latitude and longitude params if set so we don't request them again if permission is granted
          const searchParams = new URLSearchParams(window.location.search);
          let latLonParams = "";
          if (searchParams.get('latitude') && searchParams.get('longitude')) {
            latLonParams =  "&latitude=" + searchParams.get('latitude') + "&longitude=" + searchParams.get('longitude');
          }
          window.location.href = window.location.origin + window.location.pathname + filterParams + latLonParams;
        }
      });

      regionOption.addEventListener('keypress', (e) => {
        triggerClick(e);
        toggleDropDownDisplay(regionDropdown);
      });
    });
  }

  if (filterBtn) {
    filterBtn.addEventListener('click', (e) => {
      e.preventDefault();
      if (modal) {
        // Make the body fixed to prevent users scrolling the body while the modal is open
        document.body.classList.add('modal-open');
        modal.classList.remove('event-listings-filter-modal--hidden');
        // Move focus to first filter element in modal
        modal.querySelector('.event-listings-filter-modal__search-input').focus();
      }
    });
    filterBtn.addEventListener('keypress', (e) => {
      triggerClick(e);
    });
  }

}